import { render, staticRenderFns } from "./related-role-repeater.vue?vue&type=template&id=29681740&"
import script from "./related-role-repeater.vue?vue&type=script&lang=ts&"
export * from "./related-role-repeater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports